import React from 'react';
import { Typography } from "@material-ui/core";
import { Parallax } from "react-scroll-parallax";
import AppearingElement from '../Helper/AppearingElement';
import './main.css';

// Landing Pages Sections 6B and 2D combined
function CombinedBarSection(props) {
    return (
        <section className="bar-section">
            <div className="bar-section__background" />
            <section className="bar-info-section">
                <div className="bar-info-section__header">
                    {!props.hideParallax &&
                        <AppearingElement variant="fade-in">
                            <Parallax y={[-45, 25]}>
                                <Typography variant="h3">
                                    {props.header}
                                </Typography>
                            </Parallax>
                        </AppearingElement>
                    }
                    {props.hideParallax &&
                        <AppearingElement variant="zoom-down">
                            <Typography variant="h3">
                                {props.header}
                            </Typography>
                        </AppearingElement>
                    }
                </div>
                <div className="bar-info-section__content">
                    {!props.hideParallax &&
                        <AppearingElement variant="fade-in">
                            <Parallax y={[50, -25]}>
                                <Typography variant="h5">
                                    {props.content}
                                </Typography>
                            </Parallax>
                        </AppearingElement>
                    }
                    {props.hideParallax &&
                        <AppearingElement variant="zoom-down">
                            <Typography variant="h5">
                                {props.content}
                            </Typography>
                        </AppearingElement>
                    }
                </div>
                <img alt="Zip Editor Screenshot" src={props.image} className="bar-info-section__graphic" />
            </section>
            <section className="bar-video-section">
                <div className="bar-video-section__header">
                    <AppearingElement variant="zoom-down">
                        <Typography variant="h4">
                            {props.videoHeader}
                        </Typography>
                    </AppearingElement>
                </div>
                {/*
                <div className="bar-video-section__video">
                    <video preload="auto" controls playsInline onEnded={() => setShowCTA(true)} onPlay={() => setShowCTA(false)} src={props.video}>
                        Sorry, your browser doesn't support embedded videos.
                    </video>
                    {showCTA &&
                    <div className="bar-video-section__video__cta">
                        <CTAButton className="ziplyne-button--gradient" size="large" variant="contained">
                            Request a Demo
                        </CTAButton>
                    </div>
                    }
                </div>
                */}
            </section>
        </section>
    );
}

export default CombinedBarSection;